(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
    (function () {
      const bars = document.querySelectorAll('[data-announcement]:not([data-ready])');
      bars.forEach((bar) => {
        bar.setAttribute('data-ready', 'true');
        const items = bar.querySelectorAll('[data-announcement-item]');
        if (items.length < 2 || bar.dataset.autoplay !== 'true') return;

        const speed = parseInt(bar.dataset.speed, 10) || 5000;
        let index = 0;
        setInterval(() => {
          items[index].classList.remove('is-active');
          index = (index + 1) % items.length;
          items[index].classList.add('is-active');
        }, speed);
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const carousels = document.querySelectorAll('[data-featured-collection]:not([data-ready])');
    carousels.forEach((section) => {
      section.setAttribute('data-ready', 'true');

      const viewport = section.querySelector('[data-carousel-viewport]');
      if (!viewport) return;

      const prev = section.querySelector('[data-carousel-prev]');
      const next = section.querySelector('[data-carousel-next]');

      function step() {
        const first = viewport.querySelector('.featured-collection__item');
        if (!first) return viewport.clientWidth * 0.8;
        const gap = parseFloat(getComputedStyle(first.parentElement).columnGap) || 0;
        return first.getBoundingClientRect().width + gap;
      }

      function update() {
        const max = viewport.scrollWidth - viewport.clientWidth - 2;
        if (prev) prev.disabled = viewport.scrollLeft <= 2;
        if (next) next.disabled = viewport.scrollLeft >= max;
      }

      if (prev) {
        prev.addEventListener('click', () => {
          viewport.scrollBy({ left: -step(), behavior: 'smooth' });
        });
      }

      if (next) {
        next.addEventListener('click', () => {
          viewport.scrollBy({ left: step(), behavior: 'smooth' });
        });
      }

      viewport.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-header]');
    if (!header || header.dataset.ready) return;
    header.dataset.ready = 'true';

    const searchToggle = header.querySelector('[data-search-toggle]');
    const searchPanel = header.querySelector('[data-search-panel]');
    if (searchToggle && searchPanel) {
      searchToggle.addEventListener('click', () => {
        const open = searchPanel.hidden;
        searchPanel.hidden = !open;
        searchToggle.setAttribute('aria-expanded', String(open));
        if (open) {
          const input = searchPanel.querySelector('[data-search-input]');
          if (input) input.focus();
        }
      });
    }

    if (header.dataset.sticky === 'true') {
      let last = window.scrollY;
      window.addEventListener(
        'scroll',
        () => {
          const y = window.scrollY;
          header.classList.toggle('is-scrolled', y > 20);
          if (y > last && y > 200) header.classList.add('is-hidden');
          else header.classList.remove('is-hidden');
          last = y;
        },
        { passive: true }
      );
    }

    header.querySelectorAll('[data-submenu-toggle]').forEach((toggle) => {
      const parent = toggle.closest('.has-children');
      if (!parent) return;
      parent.addEventListener('mouseenter', () => {
        toggle.setAttribute('aria-expanded', 'true');
      });
      parent.addEventListener('mouseleave', () => {
        toggle.setAttribute('aria-expanded', 'false');
      });
    });

    document.querySelectorAll('[data-mobile-nav-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const nav = document.getElementById('MobileNav');
        if (!nav) return;
        const open = !nav.hasAttribute('data-open');
        if (open) nav.setAttribute('data-open', '');
        else nav.removeAttribute('data-open');
        btn.setAttribute('aria-expanded', String(open));
        document.body.classList.toggle('overflow-hidden', open);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const heroes = document.querySelectorAll('[data-hero]:not([data-ready])');
    heroes.forEach((hero) => {
      hero.setAttribute('data-ready', 'true');

      const slides = Array.from(hero.querySelectorAll('[data-hero-slide]'));
      if (slides.length < 2) return;

      const dots = Array.from(hero.querySelectorAll('[data-hero-dot]'));
      const prev = hero.querySelector('[data-hero-prev]');
      const next = hero.querySelector('[data-hero-next]');
      const autoplay = hero.dataset.autoplay === 'true';
      const speed = parseInt(hero.dataset.speed, 10) || 6000;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      let index = 0;
      let timer = null;

      function show(target) {
        index = (target + slides.length) % slides.length;

        slides.forEach((slide, position) => {
          const active = position === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        dots.forEach((dot, position) => {
          const active = position === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      function stop() {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      }

      function start() {
        if (!autoplay || reduceMotion || timer) return;
        timer = window.setInterval(() => show(index + 1), speed);
      }

      if (prev) prev.addEventListener('click', () => { stop(); show(index - 1); start(); });
      if (next) next.addEventListener('click', () => { stop(); show(index + 1); start(); });

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          stop();
          show(parseInt(dot.dataset.heroIndex, 10) || 0);
          start();
        });
      });

      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
      hero.addEventListener('focusin', stop);

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stop();
        } else {
          start();
        }
      });

      hero.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          stop();
          show(index - 1);
          start();
        }

        if (event.key === 'ArrowRight') {
          stop();
          show(index + 1);
          start();
        }
      });

      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  (function () {
    // Shopify exposes province data per country; swap the province select on change.
    const provincesByCountry = window.Shopify && window.Shopify.countryProvinceNames ? {} : {};
    document.querySelectorAll('[data-address-country]').forEach((countrySelect) => {
      if (countrySelect.dataset.ready) return;
      countrySelect.dataset.ready = 'true';

      const form = countrySelect.closest('form');
      const provinceSelect = form ? form.querySelector('[data-address-province]') : null;
      if (!provinceSelect) return;

      const sync = () => {
        const selected = countrySelect.options[countrySelect.selectedIndex];
        const provinces = selected && selected.dataset ? selected.dataset.provinces : null;
        provinceSelect.innerHTML = '';
        if (!provinces) return;
        try {
          JSON.parse(provinces).forEach((province) => {
            const option = document.createElement('option');
            option.value = province[0];
            option.textContent = province[1];
            provinceSelect.appendChild(option);
          });
        } catch (err) {
          /* country has no province list */
        }
      };

      countrySelect.addEventListener('change', sync);
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (function () {
    const inputs = document.querySelectorAll('[data-cart-qty]');
    let timer = null;
    inputs.forEach((input) => {
      input.addEventListener('change', () => {
        const form = input.closest('form');
        if (!form) return;
        clearTimeout(timer);
        timer = setTimeout(() => form.querySelector('[name="update"]').click(), 400);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-sort-select]').forEach((select) => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });

    document.querySelectorAll('[data-facet-form]').forEach((form) => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const params = new URLSearchParams();
        const data = new FormData(form);
        for (const [key, value] of data.entries()) {
          if (value !== '') params.append(key, value);
        }
        const sort = new URL(window.location.href).searchParams.get('sort_by');
        if (sort) params.set('sort_by', sort);
        window.location.href = `${window.location.pathname}?${params.toString()}`;
      });
    });

    document.querySelectorAll('[data-facet-toggle]').forEach((btn) => {
      if (btn.dataset.ready) return;
      btn.dataset.ready = 'true';
      btn.addEventListener('click', () => {
        const panel = document.getElementById('FacetPanel');
        if (!panel) return;
        const open = !panel.hasAttribute('data-open');
        if (open) panel.setAttribute('data-open', '');
        else panel.removeAttribute('data-open');
        btn.setAttribute('aria-expanded', String(open));
      });
    });

    document.querySelectorAll('[data-facet-close]').forEach((btn) => {
      if (btn.dataset.ready) return;
      btn.dataset.ready = 'true';
      btn.addEventListener('click', () => {
        const panel = document.getElementById('FacetPanel');
        if (panel) panel.removeAttribute('data-open');
        const toggle = document.querySelector('[data-facet-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
